// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-cell {
	display: table-cell;
	max-width: 420px;
	width: 320px;
	vertical-align: top; 
	float: right;
	align-content: center;
	background-color: #f3f3f3;
	top: 0;
	padding-bottom: 13px !important;
}

.right-cell-h-scrollable {
	background-color: #f0f0f0;
	width: 100%;  
	height: 100% !important;
}

.right-rail {
	position: relative;  
	width: 100%;
	padding: 0 0 0 10px;
	float: right;  
	background: #f3f3f3;
	border-left: 1px solid #d5d5d5;
	border-top: 0;
	overflow-y: scroll; 
}

.right-rail-content {
	position: relative;
	width: 100%;
	min-width: 210px 
}

.right-rail-content .radio {
	margin: 0;
}

.right-rail-content .form-group {
	margin-bottom: 0;
}

.right-rail-content .sp-preview {
	height: 19px !important;
}

.propStyleTab {
	padding-right: 0 !important;
	overflow: hidden;
}

.propStyleTab .prop-detai, .propStyleTab .prop-detail{
	width: 420px !important;
}

.propStyleTab .prop-header > .prop-label {
	font-size: 1.2rem;
}

.propStyleTab .themeTextRows {
	margin-top: 0 !important;
}

.propStyleTab .prop-detail {
	margin: 0 !important;
}

.propStyleTab .prop-sublabel {
	padding-left: 0 !important;
	padding-right: 0 !important;
	white-space: nowrap;  
    overflow: hidden;
    text-overflow: ellipsis; 
}

.propStyleTab .prop-sublabel-expanded{
	width: 24% !important;
	margin-left: 15px;
}

.propStyleTab .prop-sublabel-collapsed {
	width: 24% !important;
	margin-left: 15px;
}

#settings .ui-corner-bottom {
	overflow-x: hidden;
}

#settings .prop-header {
	margin: 10px 0 3px 0;
	display: inline-block;
}

#settings:nth-child(2) {
	margin: 0;
}

#settings:last-child {
	margin: 0 0 10px 0;
}

#settings .input-group-btn-vertical > .btn {
	margin-bottom: 0 !important;
	padding: 4px 12px !important;
}

#property-tabs button {
	width: 75px;
	padding: 4px;
}

#property-tabs .copy-fields {
	width: 18px;
	padding: 1px;
}

#property-tabs .select-button {
	width: 100%;
	max-width: 75px;
	overflow: hidden;
}

#settings #propMainGridButtons button {
	width: 100%; padding: 5px 0
}

.tab-content .button-selector {
	width: 25px !important; padding: 2px 4px 5px 4px !important;
}

.tab-content .subsection {
	display: -ms-flexbox;
	display: inline-flex;
}

.tab-content .subsection label { 
	float: left;
}

.tab-content .subsection > div { 
	width: 100%;
}

.tab-content .subsection .label-20 {
	width: 20px; min-width: 20px;
}

.tab-content .subsection .label-30 {
	width: 30px; min-width: 30px;
}
.tab-content .subsection .label-35 {
	width: 35px; min-width: 35px;
}

.tab-content  .subsection .label-40 {
	width: 40px; min-width: 40px;
}

.tab-content .subsection .label-45 {
	width: 45px; min-width: 45px;
}

.tab-content .subsection .label-50 {
	width: 50px; min-width: 50px;
}

.tab-content .subsection .label-55 {
	width: 55px !important; min-width: 55px !important;margin-top:2px!important;
}

.tab-content .subsection .label-60 {
	width: 60px; min-width: 60px;
}

.tab-content .subsection .label-65 {
	width: 65px !important; min-width: 65px;
}

.tab-content .subsection .label-70 {
	width: 70px !important; min-width: 70px;
}

.tab-content .subsection .label-75 {
	width: 75px !important; min-width: 75px;
}

.tab-content .subsection .label-80 {
	width: 80px !important; min-width: 80px;
}

.tab-content .subsection .label-85 {
	width: 85px !important; min-width: 85px;
}

.tab-content .subsection .label-90 {
	width: 90px !important; min-width: 90px;
}

.tab-content .subsection .label-95 {
	width: 95px !important; min-width: 95px;
}

.tab-content .subsection .label-110 {
	width: 110px; min-width: 110px;
}

.tab-content .subsection .label-130 {
	width: 130px; min-width: 130px;
}


.tab-content .subsection .label-135 {
	width: 135px; min-width: 135px;
}


.tab-content .subsection .button-opener {
	text-align: right; margin-left: 5px !important;
}

#propStyle .custom-combobox-input {
	width: 36px !important;
	margin-right: 21px;
}

#propStyle .custom-combobox-toggle {
	margin-left: -22px;
}

#sliderColor {
	margin-left: 8px;
}

@-moz-document url-prefix() {
	.right-rail-content {
		height: 80vh;
		-webkit-transition: height 0.5s;
		-moz-transition: height 0.5s;
		-ms-transition: height 0.5s;
		-o-transition: height 0.5s;
		transition: height 0.5s;
	}
}

@media screen and (min-height: 600px) and (max-height: 768px) {
	@-moz-document url-prefix() {
		.right-rail-content {
			height: 60vh !important;
			-webkit-transition: height 0.5s;
			-moz-transition: height 0.5s;
			-ms-transition: height 0.5s;
			-o-transition: height 0.5s;
			transition: height 0.5s;
		}
	}
}

@media screen and (min-height: 769px) and (max-height: 960px) {
	@-moz-document url-prefix() {
		.right-rail-content {
			height: 67vh !important;
			-webkit-transition: height 0.5s;
			-moz-transition: height 0.5s;
			-ms-transition: height 0.5s;
			-o-transition: height 0.5s;
			transition: height 0.5s;
		}
	}
}

@media screen and (min-height: 961px) and (max-height: 1200px) {
	@-moz-document url-prefix() {
		.right-rail-content {
			height: 76vh !important;
			-webkit-transition: height 0.5s;
			-moz-transition: height 0.5s;
			-ms-transition: height 0.5s;
			-o-transition: height 0.5s;
			transition: height 0.5s;
		}
	}
}

#rightRailScroller .rail-header,
.left-cell .rail-header{
	position: relative;
	margin: 0;
	padding: 7px 15px;
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	width: 100%;
}


#rightRailScroller .rail-header .hide-title {
    color: transparent;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 15px;
}

#rightRailScroller .rail-header .help {
	right: 3px;
}

#rightRailScroller .rail-header h2,
.left-cell .rail-header h2 {
	position: relative;
	margin: 0 0 0 40px;
	padding: 0;
	color:  var(--main-primary);
	font-size: 15px;
	font-size: 1.5rem;
	width: 93%;
	white-space: nowrap;
}

#rightRailScroller .rail-header .toggle,
.left-cell .rail-header .toggle {
	display: block;
	position: absolute;
	left: 9px;
	top: 0;
	height: 100%;
	padding: 7px 10px;
	background: rgba(94,140,38, 0.10);
	vertical-align: middle;
	color:  var(--main-primary);
	font-weight: bold;
	font-size: 15px;
}

.right-cell .ui-resizable-w  {
	left: 0 !important;
	width: 10px !important;
	background: rgba(94,140,38, 0.10) !important;
}

 

.left-cell .rail-header .toggle {
	left: auto;
	right: 0 !important;
}

.left-cell .rail-header h2 {
	margin: 0 25px 0 -5px;
	text-align: right;
	min-width: 125px;
}

.breadcrumb {
	/* PF-2611 begin: */
	white-space: nowrap;
	width: 12em;
	overflow: hidden;
	text-overflow: ellipsis;
	/* end :PF-2611 */
	width: 100%;
	margin: 0 auto;
	padding: 8px 15px;
	background: rgba(225,225,225,0.5);
	box-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);
	-moz-box-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);
	-webkit-box-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);
	border-radius: 0px;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
}

.left-breadcrumb {
    width: 100%;
	padding: 8px 18px;
	padding: 8px 19px 8px 30px;
}

.right-breadcrumb {
	padding: 8px 19px 8px 10px;
    margin-left: -1px;
}


/* MODIFIED */
.breadcrumb div {
	display: inline-block;
	margin: 0;
	padding: 0;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
	font-size: 13px;
	font-size: 1.3rem;
}
/* MODIFIED */
.breadcrumb div:last-child {
	padding-right: 0;
}

.breadcrumb div:hover {
	cursor: pointer;
}

.breadcrumb a {
	padding: 0;
	color: #333;
}
/* MODIFIED */
.breadcrumb div.active {
	color: var(--main-primary);
	font-weight: bold;
}
/* MODIFIED */
.attributes-section, .behaviors-section {
	position: relative;
	width: 100%;
	padding: 10px 15px;
	display: inline-block; /* MODIFIED */
}

.behaviors-section { 
	padding-top: 0; 
}

.attributes-section h3, .behaviors-section h3 {
	display: block;
	width: 100%;
	margin: 0;
	padding: 0;
	color: #333;
	font-size: 1.3rem;
}

.attributes-section h3 a, .behaviors-section h3 a {
	color: #444;
}

.attributes-section h3 a:hover, .behaviors-section h3 a:hover {
	text-decoration: none;
}

.attributes-section h3 i, .behaviors-section h3 i {
	float: right;
	font-size: 15px;
}

.attributes-section h3:hover, .behaviors-section h3:hover {
	cursor: pointer;
}

.attribute-options, .behavior-options {
	margin: 5px 0 0;
	padding: 0 15px;
}

.attribute-options li, .behavior-options li {
	display: block;
	margin: 0;
	padding: 0;
	font-size: 11px;
	font-size: 1.1rem;
	list-style: none;
	min-width: 190px;
}

.attribute-options li a, .behavior-options li a {
	color: #444;
	font-weight: 400;
}

.attribute-options li a:hover, .behavior-options li a:hover {
	text-decoration: none;
}

.attribute-options li a.active, .behavior-options li a.active {
	padding-left: 0px;
	color:  var(--main-primary);
	font-weight: 500;
}

.attribute-options li a.active:before, .behavior-options li a.active:before {
	content: '\\f013';
	font-family:"FontAwesome";
	padding-right: 5px;
}

.attribute-options input[type="text"], .behavior-options input[type="text"] {
	width: 100%;
	padding: 5px 2%;
	
	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;

	font-size: 11px;
	font-size: 1.1rem;
}

.settings-style-access {
	padding: 0 10px 0 10px;
	min-width: 275px;
}

.settings-style-access > .nav-tabs > li > a {
	border-top: 1px solid #d5d5d5;
	font-size: 12px;
	font-size: 1.2rem;
}

.settings-style-access .row, #prop-behavior-view .row {
	margin: 0 0 1px 0;
	padding: 1px 0;
}

.settings-style-access .section {
	margin-top: 25px;
}

.settings-style-access .styled-select {
	margin-top: 0px;
}

.settings-style-access .input-group-addon {
	background-color: transparent !important;
	border: 0px !important;
}

.settings-style-access .input-group .form-control:last-child, .settings-style-access .input-group-addon:last-child, .settings-style-access .input-group-btn:last-child > .btn, .settings-style-access .input-group-btn:last-child > .btn-group > .btn, 
.settings-style-access .input-group-btn:last-child > .dropdown-toggle, .input-group-btn:first-child > .btn:not(:first-child), .settings-style-access .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
}

.settings-style-access .label {
	display: inline-block;
	padding: 8px 0 0;
	color: #333;
	font-size: 16px;
	font-size: 1.6rem;
	font-weight: normal;
	text-align: left;
}`, "",{"version":3,"sources":["webpack://./assets/style/partials/right-rail.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,qBAAqB;CACrB,yBAAyB;CACzB,MAAM;CACN,+BAA+B;AAChC;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX;AACD;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,mBAAmB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;AACtB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW,EAAE;AACd;;AAEA;CACC,sBAAsB,EAAE,mCAAmC;AAC5D;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;AACA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,sBAAsB,EAAE,0BAA0B,CAAC,wBAAwB;AAC5E;;AAEA;CACC,WAAW,EAAE,eAAe;AAC7B;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;CACC,YAAY,EAAE,gBAAgB;AAC/B;;AAEA;CACC,YAAY,EAAE,gBAAgB;AAC/B;;;AAGA;CACC,YAAY,EAAE,gBAAgB;AAC/B;;;AAGA;CACC,iBAAiB,EAAE,2BAA2B;AAC/C;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC;GACC,uBAAuB;GACvB,+BAA+B;GAC/B,4BAA4B;GAC5B,2BAA2B;GAC3B,0BAA0B;GAC1B,uBAAuB;EACxB;CACD;AACD;;AAEA;CACC;EACC;GACC,uBAAuB;GACvB,+BAA+B;GAC/B,4BAA4B;GAC5B,2BAA2B;GAC3B,0BAA0B;GAC1B,uBAAuB;EACxB;CACD;AACD;;AAEA;CACC;EACC;GACC,uBAAuB;GACvB,+BAA+B;GAC/B,4BAA4B;GAC5B,2BAA2B;GAC3B,0BAA0B;GAC1B,uBAAuB;EACxB;CACD;AACD;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;CAC/H,WAAW;AACZ;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,2BAA2B;CAC3B,eAAe;CACf,iBAAiB;CACjB,UAAU;CACV,mBAAmB;AACpB;;AAEA;;CAEC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,MAAM;CACN,YAAY;CACZ,iBAAiB;CACjB,iCAAiC;CACjC,sBAAsB;CACtB,2BAA2B;CAC3B,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,4CAA4C;AAC7C;;;;AAIA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,uBAAuB;CACvB,iBAAiB;CACjB,WAAW;CACX,cAAc;CACd,iBAAiB;CACjB,iCAAiC;CACjC,6CAA6C;CAC7C,kDAAkD;CAClD,qDAAqD;CACrD,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;IACI,WAAW;CACd,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;IACvB,iBAAiB;AACrB;;;AAGA,aAAa;AACb;CACC,qBAAqB;CACrB,SAAS;CACT,UAAU;CACV,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;AACA,aAAa;AACb;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;AACA,aAAa;AACb;CACC,0BAA0B;CAC1B,iBAAiB;AAClB;AACA,aAAa;AACb;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,SAAS;CACT,UAAU;CACV,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,SAAS;CACT,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;;CAEf,yBAAyB;CACzB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;;CAExB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wCAAwC;CACxC,sBAAsB;AACvB;;AAEA;;CAEC,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB","sourcesContent":[".right-cell {\r\n\tdisplay: table-cell;\r\n\tmax-width: 420px;\r\n\twidth: 320px;\r\n\tvertical-align: top; \r\n\tfloat: right;\r\n\talign-content: center;\r\n\tbackground-color: #f3f3f3;\r\n\ttop: 0;\r\n\tpadding-bottom: 13px !important;\r\n}\r\n\r\n.right-cell-h-scrollable {\r\n\tbackground-color: #f0f0f0;\r\n\twidth: 100%;  \r\n\theight: 100% !important;\r\n}\r\n\r\n.right-rail {\r\n\tposition: relative;  \r\n\twidth: 100%;\r\n\tpadding: 0 0 0 10px;\r\n\tfloat: right;  \r\n\tbackground: #f3f3f3;\r\n\tborder-left: 1px solid #d5d5d5;\r\n\tborder-top: 0;\r\n\toverflow-y: scroll; \r\n}\r\n\r\n.right-rail-content {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmin-width: 210px \r\n}\r\n\r\n.right-rail-content .radio {\r\n\tmargin: 0;\r\n}\r\n\r\n.right-rail-content .form-group {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.right-rail-content .sp-preview {\r\n\theight: 19px !important;\r\n}\r\n\r\n.propStyleTab {\r\n\tpadding-right: 0 !important;\r\n\toverflow: hidden;\r\n}\r\n\r\n.propStyleTab .prop-detai, .propStyleTab .prop-detail{\r\n\twidth: 420px !important;\r\n}\r\n\r\n.propStyleTab .prop-header > .prop-label {\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.propStyleTab .themeTextRows {\r\n\tmargin-top: 0 !important;\r\n}\r\n\r\n.propStyleTab .prop-detail {\r\n\tmargin: 0 !important;\r\n}\r\n\r\n.propStyleTab .prop-sublabel {\r\n\tpadding-left: 0 !important;\r\n\tpadding-right: 0 !important;\r\n\twhite-space: nowrap;  \r\n    overflow: hidden;\r\n    text-overflow: ellipsis; \r\n}\r\n\r\n.propStyleTab .prop-sublabel-expanded{\r\n\twidth: 24% !important;\r\n\tmargin-left: 15px;\r\n}\r\n\r\n.propStyleTab .prop-sublabel-collapsed {\r\n\twidth: 24% !important;\r\n\tmargin-left: 15px;\r\n}\r\n\r\n#settings .ui-corner-bottom {\r\n\toverflow-x: hidden;\r\n}\r\n\r\n#settings .prop-header {\r\n\tmargin: 10px 0 3px 0;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n#settings:nth-child(2) {\r\n\tmargin: 0;\r\n}\r\n\r\n#settings:last-child {\r\n\tmargin: 0 0 10px 0;\r\n}\r\n\r\n#settings .input-group-btn-vertical > .btn {\r\n\tmargin-bottom: 0 !important;\r\n\tpadding: 4px 12px !important;\r\n}\r\n\r\n#property-tabs button {\r\n\twidth: 75px;\r\n\tpadding: 4px;\r\n}\r\n\r\n#property-tabs .copy-fields {\r\n\twidth: 18px;\r\n\tpadding: 1px;\r\n}\r\n\r\n#property-tabs .select-button {\r\n\twidth: 100%;\r\n\tmax-width: 75px;\r\n\toverflow: hidden;\r\n}\r\n\r\n#settings #propMainGridButtons button {\r\n\twidth: 100%; padding: 5px 0\r\n}\r\n\r\n.tab-content .button-selector {\r\n\twidth: 25px !important; padding: 2px 4px 5px 4px !important;\r\n}\r\n\r\n.tab-content .subsection {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.tab-content .subsection label { \r\n\tfloat: left;\r\n}\r\n\r\n.tab-content .subsection > div { \r\n\twidth: 100%;\r\n}\r\n\r\n.tab-content .subsection .label-20 {\r\n\twidth: 20px; min-width: 20px;\r\n}\r\n\r\n.tab-content .subsection .label-30 {\r\n\twidth: 30px; min-width: 30px;\r\n}\r\n.tab-content .subsection .label-35 {\r\n\twidth: 35px; min-width: 35px;\r\n}\r\n\r\n.tab-content  .subsection .label-40 {\r\n\twidth: 40px; min-width: 40px;\r\n}\r\n\r\n.tab-content .subsection .label-45 {\r\n\twidth: 45px; min-width: 45px;\r\n}\r\n\r\n.tab-content .subsection .label-50 {\r\n\twidth: 50px; min-width: 50px;\r\n}\r\n\r\n.tab-content .subsection .label-55 {\r\n\twidth: 55px !important; min-width: 55px !important;margin-top:2px!important;\r\n}\r\n\r\n.tab-content .subsection .label-60 {\r\n\twidth: 60px; min-width: 60px;\r\n}\r\n\r\n.tab-content .subsection .label-65 {\r\n\twidth: 65px !important; min-width: 65px;\r\n}\r\n\r\n.tab-content .subsection .label-70 {\r\n\twidth: 70px !important; min-width: 70px;\r\n}\r\n\r\n.tab-content .subsection .label-75 {\r\n\twidth: 75px !important; min-width: 75px;\r\n}\r\n\r\n.tab-content .subsection .label-80 {\r\n\twidth: 80px !important; min-width: 80px;\r\n}\r\n\r\n.tab-content .subsection .label-85 {\r\n\twidth: 85px !important; min-width: 85px;\r\n}\r\n\r\n.tab-content .subsection .label-90 {\r\n\twidth: 90px !important; min-width: 90px;\r\n}\r\n\r\n.tab-content .subsection .label-95 {\r\n\twidth: 95px !important; min-width: 95px;\r\n}\r\n\r\n.tab-content .subsection .label-110 {\r\n\twidth: 110px; min-width: 110px;\r\n}\r\n\r\n.tab-content .subsection .label-130 {\r\n\twidth: 130px; min-width: 130px;\r\n}\r\n\r\n\r\n.tab-content .subsection .label-135 {\r\n\twidth: 135px; min-width: 135px;\r\n}\r\n\r\n\r\n.tab-content .subsection .button-opener {\r\n\ttext-align: right; margin-left: 5px !important;\r\n}\r\n\r\n#propStyle .custom-combobox-input {\r\n\twidth: 36px !important;\r\n\tmargin-right: 21px;\r\n}\r\n\r\n#propStyle .custom-combobox-toggle {\r\n\tmargin-left: -22px;\r\n}\r\n\r\n#sliderColor {\r\n\tmargin-left: 8px;\r\n}\r\n\r\n@-moz-document url-prefix() {\r\n\t.right-rail-content {\r\n\t\theight: 80vh;\r\n\t\t-webkit-transition: height 0.5s;\r\n\t\t-moz-transition: height 0.5s;\r\n\t\t-ms-transition: height 0.5s;\r\n\t\t-o-transition: height 0.5s;\r\n\t\ttransition: height 0.5s;\r\n\t}\r\n}\r\n\r\n@media screen and (min-height: 600px) and (max-height: 768px) {\r\n\t@-moz-document url-prefix() {\r\n\t\t.right-rail-content {\r\n\t\t\theight: 60vh !important;\r\n\t\t\t-webkit-transition: height 0.5s;\r\n\t\t\t-moz-transition: height 0.5s;\r\n\t\t\t-ms-transition: height 0.5s;\r\n\t\t\t-o-transition: height 0.5s;\r\n\t\t\ttransition: height 0.5s;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media screen and (min-height: 769px) and (max-height: 960px) {\r\n\t@-moz-document url-prefix() {\r\n\t\t.right-rail-content {\r\n\t\t\theight: 67vh !important;\r\n\t\t\t-webkit-transition: height 0.5s;\r\n\t\t\t-moz-transition: height 0.5s;\r\n\t\t\t-ms-transition: height 0.5s;\r\n\t\t\t-o-transition: height 0.5s;\r\n\t\t\ttransition: height 0.5s;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media screen and (min-height: 961px) and (max-height: 1200px) {\r\n\t@-moz-document url-prefix() {\r\n\t\t.right-rail-content {\r\n\t\t\theight: 76vh !important;\r\n\t\t\t-webkit-transition: height 0.5s;\r\n\t\t\t-moz-transition: height 0.5s;\r\n\t\t\t-ms-transition: height 0.5s;\r\n\t\t\t-o-transition: height 0.5s;\r\n\t\t\ttransition: height 0.5s;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n#rightRailScroller .rail-header,\r\n.left-cell .rail-header{\r\n\tposition: relative;\r\n\tmargin: 0;\r\n\tpadding: 7px 15px;\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\twidth: 100%;\r\n}\r\n\r\n\r\n#rightRailScroller .rail-header .hide-title {\r\n    color: transparent;\r\n    display: block;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    margin-left: 15px;\r\n}\r\n\r\n#rightRailScroller .rail-header .help {\r\n\tright: 3px;\r\n}\r\n\r\n#rightRailScroller .rail-header h2,\r\n.left-cell .rail-header h2 {\r\n\tposition: relative;\r\n\tmargin: 0 0 0 40px;\r\n\tpadding: 0;\r\n\tcolor:  var(--main-primary);\r\n\tfont-size: 15px;\r\n\tfont-size: 1.5rem;\r\n\twidth: 93%;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n#rightRailScroller .rail-header .toggle,\r\n.left-cell .rail-header .toggle {\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tleft: 9px;\r\n\ttop: 0;\r\n\theight: 100%;\r\n\tpadding: 7px 10px;\r\n\tbackground: rgba(94,140,38, 0.10);\r\n\tvertical-align: middle;\r\n\tcolor:  var(--main-primary);\r\n\tfont-weight: bold;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.right-cell .ui-resizable-w  {\r\n\tleft: 0 !important;\r\n\twidth: 10px !important;\r\n\tbackground: rgba(94,140,38, 0.10) !important;\r\n}\r\n\r\n \r\n\r\n.left-cell .rail-header .toggle {\r\n\tleft: auto;\r\n\tright: 0 !important;\r\n}\r\n\r\n.left-cell .rail-header h2 {\r\n\tmargin: 0 25px 0 -5px;\r\n\ttext-align: right;\r\n\tmin-width: 125px;\r\n}\r\n\r\n.breadcrumb {\r\n\t/* PF-2611 begin: */\r\n\twhite-space: nowrap;\r\n\twidth: 12em;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\t/* end :PF-2611 */\r\n\twidth: 100%;\r\n\tmargin: 0 auto;\r\n\tpadding: 8px 15px;\r\n\tbackground: rgba(225,225,225,0.5);\r\n\tbox-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);\r\n\t-moz-box-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);\r\n\t-webkit-box-shadow: inset 0px 0px 5px rgba(0,0,0,0.2);\r\n\tborder-radius: 0px;\r\n\t-moz-border-radius: 0px;\r\n\t-webkit-border-radius: 0px;\r\n}\r\n\r\n.left-breadcrumb {\r\n    width: 100%;\r\n\tpadding: 8px 18px;\r\n\tpadding: 8px 19px 8px 30px;\r\n}\r\n\r\n.right-breadcrumb {\r\n\tpadding: 8px 19px 8px 10px;\r\n    margin-left: -1px;\r\n}\r\n\r\n\r\n/* MODIFIED */\r\n.breadcrumb div {\r\n\tdisplay: inline-block;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n\tfont-size: 13px;\r\n\tfont-size: 1.3rem;\r\n}\r\n/* MODIFIED */\r\n.breadcrumb div:last-child {\r\n\tpadding-right: 0;\r\n}\r\n\r\n.breadcrumb div:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.breadcrumb a {\r\n\tpadding: 0;\r\n\tcolor: #333;\r\n}\r\n/* MODIFIED */\r\n.breadcrumb div.active {\r\n\tcolor: var(--main-primary);\r\n\tfont-weight: bold;\r\n}\r\n/* MODIFIED */\r\n.attributes-section, .behaviors-section {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tpadding: 10px 15px;\r\n\tdisplay: inline-block; /* MODIFIED */\r\n}\r\n\r\n.behaviors-section { \r\n\tpadding-top: 0; \r\n}\r\n\r\n.attributes-section h3, .behaviors-section h3 {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tcolor: #333;\r\n\tfont-size: 1.3rem;\r\n}\r\n\r\n.attributes-section h3 a, .behaviors-section h3 a {\r\n\tcolor: #444;\r\n}\r\n\r\n.attributes-section h3 a:hover, .behaviors-section h3 a:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.attributes-section h3 i, .behaviors-section h3 i {\r\n\tfloat: right;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.attributes-section h3:hover, .behaviors-section h3:hover {\r\n\tcursor: pointer;\r\n}\r\n\r\n.attribute-options, .behavior-options {\r\n\tmargin: 5px 0 0;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.attribute-options li, .behavior-options li {\r\n\tdisplay: block;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tfont-size: 11px;\r\n\tfont-size: 1.1rem;\r\n\tlist-style: none;\r\n\tmin-width: 190px;\r\n}\r\n\r\n.attribute-options li a, .behavior-options li a {\r\n\tcolor: #444;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.attribute-options li a:hover, .behavior-options li a:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.attribute-options li a.active, .behavior-options li a.active {\r\n\tpadding-left: 0px;\r\n\tcolor:  var(--main-primary);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.attribute-options li a.active:before, .behavior-options li a.active:before {\r\n\tcontent: '\\f013';\r\n\tfont-family:\"FontAwesome\";\r\n\tpadding-right: 5px;\r\n}\r\n\r\n.attribute-options input[type=\"text\"], .behavior-options input[type=\"text\"] {\r\n\twidth: 100%;\r\n\tpadding: 5px 2%;\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n\r\n\tfont-size: 11px;\r\n\tfont-size: 1.1rem;\r\n}\r\n\r\n.settings-style-access {\r\n\tpadding: 0 10px 0 10px;\r\n\tmin-width: 275px;\r\n}\r\n\r\n.settings-style-access > .nav-tabs > li > a {\r\n\tborder-top: 1px solid #d5d5d5;\r\n\tfont-size: 12px;\r\n\tfont-size: 1.2rem;\r\n}\r\n\r\n.settings-style-access .row, #prop-behavior-view .row {\r\n\tmargin: 0 0 1px 0;\r\n\tpadding: 1px 0;\r\n}\r\n\r\n.settings-style-access .section {\r\n\tmargin-top: 25px;\r\n}\r\n\r\n.settings-style-access .styled-select {\r\n\tmargin-top: 0px;\r\n}\r\n\r\n.settings-style-access .input-group-addon {\r\n\tbackground-color: transparent !important;\r\n\tborder: 0px !important;\r\n}\r\n\r\n.settings-style-access .input-group .form-control:last-child, .settings-style-access .input-group-addon:last-child, .settings-style-access .input-group-btn:last-child > .btn, .settings-style-access .input-group-btn:last-child > .btn-group > .btn, \r\n.settings-style-access .input-group-btn:last-child > .dropdown-toggle, .input-group-btn:first-child > .btn:not(:first-child), .settings-style-access .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n}\r\n\r\n.settings-style-access .label {\r\n\tdisplay: inline-block;\r\n\tpadding: 8px 0 0;\r\n\tcolor: #333;\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\tfont-weight: normal;\r\n\ttext-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
